import React from "react";
import Modal from "react-modal";
import { ThreeDots } from "react-loader-spinner";
import crssrImage from "../../../../../images/singleinvoice/cross-red.svg";
import Plus from "../../../../../images/icons/circle-plus.svg";

const BulkImportModal = ({
  isOpen,
  onClose,
  isLoading,
  fileName,
  onFileChange,
  onUpload,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={!isLoading ? onClose : undefined}
      contentLabel="Bulk Import"
      className="bulk-import-popup"
      style={{
        content: {
          height: "50%",
          width: "50%",
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        },
      }}
    >
      <div className="modal">
        <div className="outter-modal-main">
          <a
            className="close-image-clr1"
            onClick={(e) => {
              e.preventDefault();
              onClose();
            }}
            disabled={isLoading}
          >
            <img src={crssrImage} alt="Close Bulk Import" />{" "}
          </a>
        </div>

        <div className="outter-modal-main">
          <p>Bulk Import</p>
          <form encType="multipart/form-data">
            <div className="relative w-full mb-3">
              <label className="gray-label">Select timesheet</label>
              <div className="file-input-wrapper">
                <input
                  type="text"
                  className="form-input form-input-file"
                  value={fileName}
                  readOnly
                />
                <input
                  type="file"
                  id="expFileAttchEdit"
                  name="expFileAttchEdit"
                  className="form-input hidden-input"
                  onChange={onFileChange}
                />
                <label htmlFor="expFileAttch" className="file-input-label">
                  <img src={Plus} alt="Browse" /> Browse
                </label>
              </div>
              <div className="text-sm bulk-text">
                Demo File: {"    "}
                <a
                  href="https://docs.google.com/spreadsheets/d/1YE7znnsUb2qqRzThXgtzYHWAoDrr3-hfd4_jh984CRE/edit?usp=sharing"
                  className="form-textarea"
                  target="_blank"
                  rel="noreferrer"
                >
                  timesheet_demo.xlsx
                </a>
              </div>
            </div>

            <div className="bulk-btn-section sprint-btn-outer">
              <button
                className="submit-client cancel-sprint"
                type="button"
                onClick={onClose}
                disabled={isLoading}
              >
                Close
              </button>
              <button
                className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded-full shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={onUpload}
                disabled={isLoading}
              >
                {isLoading ? (
                  <div className="outter-load-table">
                    <ThreeDots
                      height="18"
                      width="20"
                      radius="9"
                      color="white"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{}}
                      wrapperClassName=""
                      visible={true}
                    />
                  </div>
                ) : (
                  "Send"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default BulkImportModal;

